import { H6, P } from "../../../AbstractElements";
import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Row,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Media,
  Label,
  Input,
} from "reactstrap";
import { Action } from "../../../Constant";
import useAxios from "../../../Utils/useAxios";
import { Star } from "react-feather";
import Image from "../../../CommonElements/Media/index";
import { dateTimeFieldToDate } from "../../../Utils/externalFunctions";
import LoadingContainer from "../../../CommonElements/Loading";

const MailContain = ({
  filteredMailList,
  getMailList,
  mailReadMore,
  hasNext,
}) => {
  const [dropdownOpen, setOpen] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emails, setEmails] = useState(filteredMailList);
  const axiosInstance = useAxios();

  useEffect(() => {
    setEmails(filteredMailList);
  }, [filteredMailList]);

  const toggle = () => setOpen(!dropdownOpen);

  const handleCheckboxChange = (id) => {
    setSelectedEmails((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((emailId) => emailId !== id)
        : [...prevSelected, id]
    );
  };

  const handleAction = async (actionType) => {
    let apiEndpoint = "";
    switch (actionType) {
      case "markAsRead":
        apiEndpoint = "notification/readall/";
        break;
      // case "markAsUnread":
      //   apiEndpoint = "notification/mark-as-unread/";
      //   break;
      // case "delete":
      //   apiEndpoint = "notification/delete/";
      //   break;
      default:
        break;
    }

    try {
      await axiosInstance.post(apiEndpoint, { ids: selectedEmails });
      getMailList();
      setSelectedEmails([]);
    } catch (error) {
      console.error(`Error in ${actionType} action: `, error);
    }
  };

  const handleRead = async (id) => {
    try {
      await axiosInstance.put(`notification/read/${id}/`);
      setEmails((prevEmails) =>
        prevEmails.map((email) =>
          email.id === id ? { ...email, is_read: true } : email
        )
      );
      window.location.reload();
    } catch (error) {
      console.error(`Error marking as read:`, error);
    }
  };

  return (
    <Fragment>
      <div className="email-right-aside">
        <Card className="email-body">
          <div className="email-profile">
            <div className="pb-3">
              <div className="pe-0 b-r-light"></div>
              <div className="email-top">
                <Row>
                  <div className="col-12">
                    <Media>
                      <Label
                        className="email-chek d-block"
                        htmlFor="chk-ani-all"
                      >
                        <Input
                          className="checkbox_animated"
                          id="chk-ani-all"
                          type="checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              const allEmailIds = emails.map(
                                (email) => email.id
                              );
                              setSelectedEmails(allEmailIds);
                            } else {
                              setSelectedEmails([]);
                            }
                          }}
                        />
                      </Label>
                      <Media body>
                        <div className="dropdown">
                          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle color="primary" caret>
                              {Action}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                className="dropdown-item"
                                onClick={() => handleAction("markAsRead")}
                              >
                                Mark as read
                              </DropdownItem>
                              {/* <DropdownItem
                                className="dropdown-item"
                                onClick={() => handleAction("markAsUnread")}
                              >
                                Mark as unread
                              </DropdownItem>
                              <DropdownItem
                                className="dropdown-item"
                                onClick={() => handleAction("delete")}
                              >
                                Delete
                              </DropdownItem> */}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </Media>
                    </Media>
                  </div>
                </Row>
              </div>
              <LoadingContainer isPending={emails === undefined}>
                <div
                  className="inbox"
                  onScroll={(e) => {
                    const bottom =
                      e.target.scrollHeight -
                        e.target.scrollTop -
                        e.target.clientHeight <
                      2;
                  }}
                >
                  {emails &&
                    emails.map((item) => (
                      <Media
                        key={item.id}
                        className={item.is_read ? "bg-light" : ""}
                      >
                        <div className="media-size-email">
                          <Label
                            className="d-block mb-0"
                            htmlFor={`chk-ani-${item.id}`}
                          >
                            <Input
                              className="checkbox_animated"
                              id={`chk-ani-${item.id}`}
                              type="checkbox"
                              checked={selectedEmails.includes(item.id)}
                              onChange={() => handleCheckboxChange(item.id)}
                            />
                          </Label>
                        </div>

                        <Link
                          to={{
                            pathname: `${process.env.PUBLIC_URL}/email/${item.notification_object_id.module_type.module_id.module}/${item.notification_object_id.module_id}`,
                          }}
                          onClick={() => handleRead(item.id)}
                        >
                          <Media body>
                            <H6>{item.notification_object_id.actor_id}</H6>
                            <p style={{ overflow: "none" }}>
                              {`${item.notification_object_id.module_type.description} ${item.notification_object_id.module_id}`}
                            </p>
                            <span>
                              {new Date(
                                item.notification_object_id.created_on
                              ).toLocaleString()}
                            </span>
                          </Media>
                        </Link>
                      </Media>
                    ))}
                  {hasNext && (
                    <div
                      className="d-flex justify-content-center"
                      onClick={mailReadMore}
                      style={{ cursor: "pointer" }}
                    >
                      <Media>Read more...</Media>
                    </div>
                  )}
                </div>
              </LoadingContainer>
            </div>
          </div>
        </Card>
      </div>
    </Fragment>
  );
};

export default MailContain;
